export const COMPLETED_BY = {
  subject: 'subject',
  caregiver: 'caregiver',
  both: 'both',
}

export const PLATFORM_TYPE = {
  web: 'web',
  mobile: 'mobile',
  both: 'both',
}

export const COMPLETED_BY_OPTIONS = [
  { key: COMPLETED_BY.subject, text: 'Subject' },
  { key: COMPLETED_BY.caregiver, text: 'Caregiver' },
  { key: COMPLETED_BY.both, text: 'Both' },
]

export const PLATFORM_TYPE_OPTIONS = [
  { key: PLATFORM_TYPE.web, text: 'Web' },
  { key: PLATFORM_TYPE.mobile, text: 'Mobile app' },
  { key: PLATFORM_TYPE.both, text: 'Both' },
]

export const COHORT_TYPE = {
  age: 'age',
  language: 'language',
  arm: 'arm',
  periodPhase: 'period_phase',
  siteLocation: 'site_location',
  sites: 'sites',
  tracks: 'tracks',
  allParticipants: 'all_participants',
  allCaregivers: 'all_caregivers',
  allUsers: 'all_users',
}

export const completedByToAudienceCohortType = completedBy => {
  if (completedBy === COMPLETED_BY.both) return COHORT_TYPE.allUsers
  if (completedBy === COMPLETED_BY.caregiver) return COHORT_TYPE.allCaregivers
  return COHORT_TYPE.allParticipants
}

/** Baseline cohort row for deploy queue (matches legacy Schedule tab buildCohortPayload). */
export const completedByToCohortBaselineType = completedBy => {
  if (completedBy === COMPLETED_BY.caregiver) return COHORT_TYPE.allUsers
  return completedByToAudienceCohortType(completedBy)
}

export const audienceTypeToCompletedBy = audienceType => {
  if (audienceType === COHORT_TYPE.allUsers) return COMPLETED_BY.both
  if (audienceType === COHORT_TYPE.allCaregivers) return COMPLETED_BY.caregiver
  return COMPLETED_BY.subject
}
